/**
 * dir-w | backOffice
 * Shared component for list field
 *
 * Last update : August 14, 2024 | @rizkiprasetya
 */

import { Component, Input } from '@angular/core';
import { Configuration } from '../../../config/configuration';

@Component({
    selector: 'app-list-field',
    templateUrl: './list-field.component.html',
    styleUrl: './list-field.component.css',
    standalone: false
})
export class ListFieldComponent {

  protected baseURL: string = Configuration.baseURL;

  @Input() singleRow: boolean = true;
  @Input() smallCaps: boolean = false;
  @Input() type: string = 'TEXT';
  @Input() textAlign: string = 'LEFT';
  @Input() textColor: string = '';
  @Input() caption: string = '';
  @Input() value: string = '';
}
